import React from 'react';
import { Card, Form, Input, Typography } from 'antd';
import { BranchesOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Text } = Typography;

/**
 * 连线属性配置组件
 * 用于配置 BPMN sequenceFlow 的条件表达式
 * 简化版本，仅支持基本的条件表达式
 */
const SequenceFlowProperties = ({ form }) => {
  return (
    <Card 
      size="small" 
      className="mb-4"
      title={
        <div className="flex items-center space-x-2">
          <BranchesOutlined />
          <span>连线条件</span>
        </div>
      }
    >
      <Form.Item
        label="条件表达式"
        name="conditionExpression"
        className="mb-3"
        tooltip="BPMN条件表达式，使用#{expression}格式"
        rules={[
          {
            validator: (_, value) => {
              if (!value) {
                return Promise.resolve();
              }
              // 验证表达式格式
              const trimmedValue = value.trim();
              if (trimmedValue.length === 0) {
                return Promise.reject(new Error('条件表达式不能为空'));
              }
              // 检查是否符合#{...}格式
              if (!trimmedValue.startsWith('#{') || !trimmedValue.endsWith('}')) {
                return Promise.reject(new Error('条件表达式必须使用#{...}格式'));
              }
              return Promise.resolve();
            }
          }
        ]}
      >
        <TextArea 
          rows={2}
          placeholder="请输入条件表达式，例如：#{approved == false}"
        />
      </Form.Item>
      
      <div className="mt-3 p-2 bg-blue-50 rounded border border-blue-200">
        <Text type="secondary" className="text-xs">
          <strong>条件表达式格式：</strong>
          <br />• 使用 #&#123;expression&#125; 格式
          <br />• 示例：#&#123;approved == false&#125;、#&#123;amount &gt; 1000&#125;
          <br />• 表达式应返回布尔值（true/false）
        </Text>
      </div>
    </Card>
  );
};

export default SequenceFlowProperties;